import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

interface ListItemProps {
  navItem: NavItem;
}
export type NavItem = {
  navTo: string;
  title: string;
  icon: any;
  children?: NavItem[];
};

const LinkItem: React.FC<ListItemProps> = ({ navItem }) => {
  return (
    <ListLink to={navItem.navTo}>
      <ListItem button>
        <ListItemIcon>{navItem.icon}</ListItemIcon>
        <ListItemText primary={navItem.title} />
      </ListItem>
    </ListLink>
  );
};

const ListLink = styled(Link)`
  text-decoration: none;
  color: black;
  .MuiButtonBase-root {
    width: 100% !important;
    display: flex !important;
    position: relative !important;
    box-sizing: border-box !important;
    text-align: left !important;
    align-items: center !important;
    justify-content: flex-start !important;
    text-decoration: none !important;
    padding: 8px 16px !important;
  }
`;
export default LinkItem;
